export default "__VITE_ASSET__B6p6ooLW__"